import React, { useState } from "react";
import PropTypes from "prop-types";

const ImageSettings = ({ setImageFile, initParam, t_controls, t_control_label }) => {
  const [imageSrc, setImageSrc] = useState(initParam);

  const uniqueId =  Math.random().toString(36).substr(2, 9);
  
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result); 
        setImageFile(file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <h5>{t_control_label}</h5>
      <div className="chrome-picker d-flex align-items-center">

        <div className="col-lg-6 image-container">
          {imageSrc ? (
            <img
              src={imageSrc} 
              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "4px" }}
            />
          ) : ( 
            <p style={{ color: "#777", textAlign: "center" }}>
              {t_controls.no_image_text || "No image uploaded"}
            </p>
          )}
        </div>

        <div>
          <label htmlFor={`image-input-${uniqueId}`} className="btn btn-primary">
            {t_controls.upload_button || "Upload image"}
          </label>

          <input
            id={`image-input-${uniqueId}`}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
        </div>
      </div>
      <br/>
    </div>  
  )
};

ImageSettings.propTypes = {
  setImageFile: PropTypes.func.isRequired,
  initParam: PropTypes.string.isRequired,
  t_controls: PropTypes.object.isRequired,
  t_control_label: PropTypes.string.isRequired,
};

export default ImageSettings;

